import React from 'react';
import {Container,  CircularProgress} from '@mui/material'
export default class Loading extends React.Component
{
 render() {return (<Container component="main" maxWidth="xs"><CircularProgress /></Container>)}
}